var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3AB5E8;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,28.4C17.9,16.1,28.8,5.8,43.7,8.6c15.5,3.3,13.7,22.4,7.4,32c-6.2,8.8-16.6,4.1-14.7-3.4 c1.6-5.7,4.4-12.7,3-16.9c-0.6-1.8-2.1-3-3.9-3.3c-7.2-1.2-11.3,8.9-7.7,16.9l-5.2,22.4c0,0.3-0.1,0.6-0.2,1c-0.8,5.1-0.8,10,0,14.5 c0,0.3,0.5,0.5,0.7,0.2c3.2-3.7,5.7-7.9,7.4-12.8c0.1-0.3,0.2-0.7,0.3-1.1l2.8-10.8c7.4,10.3,25.9,4.3,30.3-11.4 c4.1-15-0.1-27.2-12.7-32.5c-3.8-1.6-7.9-2.3-12-2.3c-18.3,0.2-31.8,13.8-28,31.4c0.2,1.1,0.6,2.1,1,3.1c1.5,3.2,3.8,5.5,6.8,6.7 c0.7,0.3,1.5,0,1.7-0.8l1.2-3.9c0.2-0.5,0-1.1-0.3-1.5c-1.8-2.1-2.8-4.2-3.1-7.7L18.6,28.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.38413f49dd70f311e23f6f5091b77f80.svg";
export { ForwardRef as ReactComponent };